// GENERATED FILE - DO NOT EDIT.
//
// Regenerate with: make contracts-generate
// Source: contracts/copilot/** (see scripts/ci/generate_copilot_ts.py)
// The gate is regeneration-and-diff: scripts/ci/check-contract-drift.sh
// regenerates this file and fails on any difference. A hand edit that happens
// to equal generator output is indistinguishable from generator output and is
// not something the gate tries to detect; what it guarantees is that the
// committed file equals the generator's.
//
// SCRUM-305 (H0-09).

// --- Cards - copilot/cards.schema.json -----------------------------------------

export interface AgendaSlot {
  no_show_risk?: boolean;
  patient_id?: null | string;
  patient_name: string;
  procedure: string;
  status: string;
  time: string;
}

export interface ChartSeries {
  label: string;
  points: Array<Record<string, unknown>>;
  unit?: null | string;
}

export interface ConfirmationDetails {
  action: string;
  count?: null | number;
  entity_label?: null | string;
}

export interface DataPoint {
  label: string;
  trend?: "up" | "down" | "neutral" | null;
  value: string;
}

export interface DecisionEdits {
  edited_fields: Array<DisplayField>;
}

export interface DisplayField {
  label: string;
  value: string;
}

export interface FieldProvenance {
  attachment_id: string;
  page?: null | number;
}

export interface FieldReview {
  reason: "illegible" | "handwritten" | "checksum_failed" | "implausible" | "conflicting";
}

export interface FormDraftAttachment {
  bytes: number;
  id: string;
  mime: string;
  name: string;
  pages?: null | number;
  sha256: string;
}

export interface FormDraftElement {
  action: string;
  fields?: Array<SetFormField>;
  key: string;
  refs?: Array<FormDraftElementRef>;
  server_owned?: Array<string>;
  title: string;
  warnings?: Array<string>;
}

export interface FormDraftElementRef {
  field: string;
  from_element: string;
  result: string;
}

export interface FormDraftSetPins {
  ceiling_hash: string;
  ceiling_revision: number;
  tool_schema_version: string;
}

export interface FormField {
  confidence?: null | number;
  editable?: boolean;
  key: string;
  label: string;
  options?: Array<string> | null;
  previous?: null | string;
  provenance?: FieldProvenance | null;
  required?: boolean;
  review?: FieldReview | null;
  source?: "document" | "user" | "system" | "clinic" | "inferred";
  type?: "text" | "cpf" | "phone" | "date" | "time" | "email" | "select" | "textarea";
  value?: null | string;
}

export interface HITLAction {
  action_name: string;
  args_preview: HITLArgsPreview;
  description: string;
  reversible: boolean;
  risk_level: "low" | "medium" | "high" | "critical";
}

export interface HITLArgsPreview {
  display_fields: Array<DisplayField>;
}

export interface RAGDocument {
  doc_id: string;
  filename: string;
  indexed_at: string;
}

export interface SampleMessage {
  sender: "lead" | "sdr";
  text: string;
}

export interface SetFormField {
  editable?: boolean;
  key: string;
  label: string;
  options?: Array<string> | null;
  previous?: null | string;
  provenance?: FieldProvenance | null;
  required?: boolean;
  review?: FieldReview | null;
  source?: "user" | "document" | "clinic" | "inferred" | null;
  type?: "text" | "cpf" | "phone" | "date" | "time" | "email" | "select" | "textarea";
  value?: null | string;
}

export interface AgendaTimelineCard {
  card_id?: string;
  correlation_id?: null | string;
  created_at?: string;
  data_points?: Array<DataPoint>;
  date: string;
  description?: null | string;
  kind: "agenda.timeline";
  slots: Array<AgendaSlot>;
  tenant_id: string;
}

export interface ChartCard {
  card_id?: string;
  chart_type?: "line" | "bar" | "pie" | "area";
  correlation_id?: null | string;
  created_at?: string;
  description?: null | string;
  kind: "chart";
  series: Array<ChartSeries>;
  tenant_id: string;
  title: string;
}

export interface ConfirmationCard {
  card_id?: string;
  correlation_id?: null | string;
  created_at?: string;
  details?: ConfirmationDetails | null;
  kind: "confirmation";
  summary: string;
  tenant_id: string;
}

export interface FormDraftCard {
  action: string;
  card_id?: string;
  confirm_label?: string;
  correlation_id?: null | string;
  created_at?: string;
  effect_id?: string;
  fields?: Array<FormField>;
  hitl_item_id?: string;
  kind: "form.draft";
  server_owned?: Array<string>;
  summary: string;
  tenant_id: string;
  title: string;
  warnings?: Array<string>;
}

export interface FormDraftSetCard {
  attachments?: Array<FormDraftAttachment>;
  card_id?: string;
  confirm_label?: string;
  correlation_id?: null | string;
  created_at?: string;
  elements: Array<FormDraftElement>;
  expires_at: string;
  kind: "form.draft.set";
  pins: FormDraftSetPins;
  shape: string;
  summary: string;
  target_label?: null | string;
  tenant_id: string;
  title: string;
  warnings?: Array<string>;
}

export interface HITLDecisionCard {
  card_id?: string;
  correlation_id?: null | string;
  created_at?: string;
  decision_edits?: DecisionEdits | null;
  decision_reason?: null | string;
  kind: "hitl.decision";
  request_id: string;
  resolved_at: string;
  resolved_by_user_id: null | string;
  resolver_type: "user" | "system" | "agent";
  state: "approved" | "rejected" | "cancelled" | "expired";
  tenant_id: string;
}

export interface HITLRequestCard {
  action: HITLAction;
  agent_reasoning: string;
  approvals_required?: number;
  assigned_user_id?: null | string;
  card_id?: string;
  context_summary: string;
  correlation_id?: null | string;
  created_at?: string;
  expires_at: string;
  kind: "hitl.request";
  on_timeout: "auto_reject" | "notify" | "escalate";
  request_id: string;
  required_role: string;
  tenant_id: string;
}

export interface InsightCard {
  body: string;
  card_id?: string;
  correlation_id?: null | string;
  created_at?: string;
  data_points?: Array<DataPoint>;
  kind: "insight";
  tenant_id: string;
  title: string;
}

export interface PersonaBuilderCard {
  card_id?: string;
  correlation_id?: null | string;
  created_at?: string;
  kind: "persona_builder";
  name: string;
  persona_id: null | string;
  rag_documents: Array<RAGDocument>;
  role_description: string;
  system_prompt: string;
  tenant_id: string;
}

export interface RoutingRuleCard {
  card_id?: string;
  condition_summary: string;
  correlation_id?: null | string;
  created_at?: string;
  kind: "routing_rule";
  priority: number;
  rule_id: null | string;
  source: "instagram" | "whatsapp" | "website" | "other";
  target_persona_id: string;
  target_persona_name: string;
  tenant_id: string;
}

export interface SDRTemplatePreviewCard {
  card_id?: string;
  correlation_id?: null | string;
  created_at?: string;
  display_name: string;
  kind: "sdr_template_preview";
  sample_conversation: Array<SampleMessage>;
  specialty: string;
  template_key: "carla" | "julia" | "bruno";
  tenant_id: string;
}

export interface TableCard {
  card_id?: string;
  columns: Array<string>;
  correlation_id?: null | string;
  created_at?: string;
  empty_state_message?: null | string;
  filters_applied?: Record<string, unknown>;
  kind: "table";
  primary_key_column?: null | string;
  rows: Array<Array<unknown>>;
  tenant_id: string;
  total_count: number;
}

export interface ToolCompletedCard {
  action_name: string;
  affected_count: number;
  card_id?: string;
  correlation_id?: null | string;
  created_at?: string;
  kind: "tool.completed";
  reference_id?: null | string;
  result_summary: string;
  tenant_id: string;
  undo_deadline?: null | string;
  undo_hint?: null | string;
}

export type CardKind = (typeof CARD_KINDS)[number];

export type CardUnion =
  | AgendaTimelineCard
  | ChartCard
  | ConfirmationCard
  | FormDraftCard
  | FormDraftSetCard
  | HITLDecisionCard
  | HITLRequestCard
  | InsightCard
  | PersonaBuilderCard
  | RoutingRuleCard
  | SDRTemplatePreviewCard
  | TableCard
  | ToolCompletedCard;

export type CardOfKind<K extends CardKind> = Extract<CardUnion, { kind: K }>;

export const CARD_KINDS = [
  "agenda.timeline",
  "chart",
  "confirmation",
  "form.draft",
  "form.draft.set",
  "hitl.decision",
  "hitl.request",
  "insight",
  "persona_builder",
  "routing_rule",
  "sdr_template_preview",
  "table",
  "tool.completed",
] as const;

// --- Proposals - copilot/proposals.schema.json ---------------------------------

export interface BookingProposal {
  created_at?: string;
  date?: null | string;
  employee_id?: null | string;
  kind?: "booking";
  patient_name?: null | string;
  patient_phone?: null | string;
  procedure: string;
  proposal_id?: string;
  reason?: null | string;
  requires_approval?: boolean;
  scheduling_id?: null | string;
  schema_version?: "1.0";
  status?: "proposed";
  tenant_id: string;
  time?: null | string;
}

export interface HandoffProposal {
  chat_id?: null | string;
  created_at?: string;
  kind?: "handoff";
  messages_count?: number;
  patient_name?: null | string;
  procedure_interest?: null | string;
  proposal_id?: string;
  reason?: null | string;
  requires_approval?: boolean;
  schema_version?: "1.0";
  status?: "proposed";
  tenant_id: string;
}

export interface MessageProposal {
  body: string;
  created_at?: string;
  interactive?: Record<string, unknown> | null;
  kind?: "message";
  proposal_id?: string;
  reason?: null | string;
  requires_approval?: boolean;
  schema_version?: "1.0";
  status?: "proposed";
  tenant_id: string;
}

// --- Tool errors - copilot/tool-error/v1 ---------------------------------------

export interface ToolErrorWire {
  effect_id: null | string;
  error_type: "api_unavailable" | "provider_timeout" | "provider_rate_limit" | "external_api_error" | "tool_validation_error" | "invalid_message_role" | "policy_unregistered_action" | "config_missing" | "hitl_rejected" | "hitl_expired" | "hitl_cancelled" | "insufficient_permission" | "quota_exceeded" | "invalid_state" | "capability_unavailable" | "unsupported_media" | "internal_error";
  message: string;
  reason_code: "budget_steps" | "budget_tool_calls" | "budget_tokens" | "budget_usd" | "budget_daily" | "budget_monthly" | "policy_unavailable" | "policy_denied" | "needs_approval" | "approval_forbidden" | "approval_rejected" | "approval_expired" | "task_cancelled" | "task_superseded" | "tool_validation_error" | "tool_unavailable" | "compensation_expired" | "compensation_unavailable" | "compensation_stale" | "context_ref_forbidden" | "context_ref_invalid" | "lease_lost" | "capability_unknown";
  retry_possible: boolean;
  status: "error";
  user_message: string;
}

// --- Capabilities - copilot/capabilities/v1 ------------------------------------

export interface CompensationSpec {
  audit_result: "compensated" | "compensation_refused" | "compensation_expired";
  deadline: string;
  expected_version: string;
  idempotency_key: string;
  method: "POST" | "PUT" | "PATCH" | "DELETE";
  path_template: string;
  preconditions: Array<string>;
  reference: string;
}

export interface CapabilityRecord {
  capability_id: string;
  capability_version: string;
  compensation: CompensationSpec | null;
  cost_class: "cheap" | "standard" | "expensive";
  default_policy: "shadow" | "draft" | "supervised" | "guarded";
  effect: "read" | "write" | "delete";
  executor_owner: "clinisharp_api" | "agent_runtime";
  required_role: "receptionist" | "manager" | "admin" | "owner";
  reversible: boolean;
  risk: "low" | "medium" | "high" | "critical";
  title_pt_br: string;
  tool_schema_version: string;
  tools: Array<string>;
}

// --- Policy decisions - copilot/policy-decision/v1 -----------------------------

export interface PolicyDecideRequest {
  capability: string;
  capability_version: string;
  contract_version: "copilot/policy-decision/v1";
  effect: "read" | "write" | "delete";
  effect_fingerprint?: string;
  effect_id: string;
  executor_owner: "clinisharp_api" | "agent_runtime";
  plan_id?: string;
  proposed_action: Record<string, unknown>;
  resource: { id: string; type: string; };
  risk: "low" | "medium" | "high" | "critical";
  run_id: string;
  step_id?: string;
  tenant_id: string;
  tool_call_id?: string;
}

export interface PolicyDecideResponse {
  decision: "allow" | "deny" | "draft" | "supervised";
  decision_id: string;
  hitl_item_id?: string | null;
  level?: "shadow" | "draft" | "supervised" | "guarded" | null;
  policy_version?: number | null;
  reason: "no_policy" | "shadow" | "draft" | "supervised" | "guarded" | "capability_unknown" | "resource_forbidden" | "executor_owner_refused" | "cross_tenant";
}

// --- Agent tasks - copilot/task-dispatch, task-result and task-heartbeat v1 ----

export interface Budget {
  steps: number;
  tokens: number;
  tool_calls: number;
  usd: number;
}

export interface Correlation {
  tenant_hash: string;
  traceparent: string;
  tracestate?: null | string;
}

export interface Resource {
  id: string;
  type: string;
}

export type Timestamp = string;

export interface TaskDispatch {
  attempt: number;
  budget_granted: Budget;
  cancellation_token: string;
  capability_id: string;
  capability_version: string;
  correlation: Correlation;
  deadline: Timestamp;
  effect_id: string;
  lease_expires_at: Timestamp;
  lease_token: string;
  resource: Resource;
  run_id: string;
  task_id: string;
  tenant_id: string;
}

export interface InventoryRow {
  current_quantity: string;
  item_id: string;
  min_quantity: string;
  name: string;
  unit: string;
}

export interface RouterRecord {
  fallback_from?: null | string;
  model: string;
  prompt_id: string;
  prompt_version: string;
  provider: string;
  router_version: string;
  routing_reason: string;
  tool_schema_version: string;
}

export interface TaskArtifact {
  input_digest: string;
  kind?: "inventory.low_stock.draft";
  observed_at: string;
  rows: Array<InventoryRow>;
  schema_version?: "1.0";
  summary: string;
  task_id: string;
}

export interface TaskResultBase {
  [key: string]: unknown;
  artifact?: TaskArtifact;
  attempt: number;
  budget_consumed: Budget;
  effect_id: string;
  error?: ToolErrorWire;
  policy_decision_ids: Array<string>;
  router_record: RouterRecord;
  run_id: string;
  task_id: string;
}

export type TaskResult =
  | (TaskResultBase & { terminal_reason?: never; terminal_state: "done"; })
  | (TaskResultBase & { terminal_reason: "budget_steps" | "budget_tool_calls" | "budget_tokens" | "budget_usd" | "budget_daily" | "budget_monthly" | "policy_unavailable" | "policy_denied" | "needs_approval" | "approval_forbidden" | "approval_rejected" | "approval_expired" | "task_cancelled" | "task_superseded" | "tool_validation_error" | "tool_unavailable" | "compensation_expired" | "compensation_unavailable" | "compensation_stale" | "context_ref_forbidden" | "context_ref_invalid" | "lease_lost" | "capability_unknown" | "deadline_exceeded"; terminal_state: "cancelled" | "failed" | "superseded"; });

export interface TaskHeartbeat {
  heartbeat_at: string;
  lease_token: string;
  progress_note?: null | string;
  run_id: string;
}

// --- Staff inventory tasks - copilot/staff-task/v1 -----------------------------

export interface TaskActions {
  cancel: boolean;
  open_result: boolean;
  prepare_again: boolean;
}

export interface TaskDependency {
  kind: "runtime" | "run_record";
  next_retry_at: null | string;
  reason_code: "capability_unknown" | "tool_validation_error" | "policy_denied" | "tool_unavailable" | "policy_unavailable" | "budget_steps" | "budget_tool_calls" | "budget_tokens" | "budget_usd" | "budget_daily" | "budget_monthly" | "lease_lost";
}

export interface StaffTask {
  actions: TaskActions;
  attempt: number;
  cancellation_source: "user" | "authority_revoked" | "replaced" | "disabled" | null;
  created_at: string;
  deadline: string;
  dependency: TaskDependency | null;
  detail_code: "attempt_limit" | null;
  id: string;
  kind: "inventory.low_stock.draft";
  next_retry_at: null | string;
  phase: "queued" | "reading_inventory" | "drafting" | "recording" | "publishing" | "retry_wait" | "finished";
  replacement_task_id: null | string;
  result_expires_at: null | string;
  result_ref: null | string;
  revision: number;
  schema_version: "1.0";
  state: "queued" | "leased" | "running" | "waiting_approval" | "retry_wait" | "done" | "failed" | "cancelled" | "superseded";
  terminal_reason: "capability_unknown" | "tool_validation_error" | "policy_denied" | "tool_unavailable" | "policy_unavailable" | "budget_steps" | "budget_tool_calls" | "budget_tokens" | "budget_usd" | "budget_daily" | "budget_monthly" | "task_cancelled" | "task_superseded" | "deadline_exceeded" | "lease_lost" | "approval_expired" | "approval_rejected" | null;
  title: string;
  updated_at: string;
}

export interface TaskView {
  actions: TaskActions;
  attempt: number;
  cancellation_source: "user" | "authority_revoked" | "replaced" | "disabled" | null;
  created_at: string;
  deadline: string;
  dependency: TaskDependency | null;
  detail_code: "attempt_limit" | null;
  id: string;
  kind: "inventory.low_stock.draft";
  next_retry_at: null | string;
  phase: "queued" | "reading_inventory" | "drafting" | "recording" | "publishing" | "retry_wait" | "finished";
  replacement_task_id: null | string;
  result_expires_at: null | string;
  result_ref: null | string;
  revision: number;
  schema_version: "1.0";
  state: "queued" | "leased" | "running" | "waiting_approval" | "retry_wait" | "done" | "failed" | "cancelled" | "superseded";
  terminal_reason: "capability_unknown" | "tool_validation_error" | "policy_denied" | "tool_unavailable" | "policy_unavailable" | "budget_steps" | "budget_tool_calls" | "budget_tokens" | "budget_usd" | "budget_daily" | "budget_monthly" | "task_cancelled" | "task_superseded" | "deadline_exceeded" | "lease_lost" | "approval_expired" | "approval_rejected" | null;
  title: string;
  updated_at: string;
}

export interface StaffTaskList {
  availability: "available" | "disabled" | "forbidden";
  data: Array<TaskView>;
  next_cursor: null | string;
}

export interface InventoryTaskArtifact {
  input_digest: string;
  kind?: "inventory.low_stock.draft";
  observed_at: string;
  rows: Array<InventoryRow>;
  schema_version?: "1.0";
  summary: string;
  task_id: string;
}

export interface CreateStaffTask {
  kind: "inventory.low_stock.draft";
  parameters: Record<string, unknown>;
  replaces_task_id?: null | string;
}

// --- Page context - copilot/page-context-request and page-context-resolved v1 --

export interface PageContextRef {
  id: string;
  type: PageContextRefType;
}

export type PageContextRefType = "patient" | "lead" | "scheduling" | "stock_item";

export interface PageContextRequestV1 {
  refs: Array<PageContextRef>;
  route: string;
  version: "copilot/page-context-request/v1";
}

export interface ContextBlock {
  fields: Record<string, string>;
  kind: PageContextRefType;
  origin_ref: string;
  retrieved_at: string;
  source: "page_context";
  trust: "untrusted";
}

export interface PageContextFailure {
  origin_ref: string;
  reason: PageContextFailureReason;
  type: PageContextRefType;
}

export type PageContextFailureReason = "context_ref_invalid" | "context_ref_forbidden";

export interface PageContextResolvedV1 {
  blocks: Array<ContextBlock>;
  failures: Array<PageContextFailure>;
  route: string;
  version: "copilot/page-context-resolved/v1";
}

// --- Form sets - copilot/form-sets/v1 ------------------------------------------

export interface FormSetShape {
  elements: Record<string, "confirm_patient" | "confirm_patient_update" | "confirm_appointment" | "confirm_stock_item">;
  max_elements: number;
  refs: Record<string, string>;
  shape: string;
}

export interface FormSetAppointmentDto {
  comments?: string | null;
  date: string;
  employeesId: string;
  hour: Array<string>;
  patientsId: FormSetPatientRef;
  proceduresId: string;
  return?: boolean | null;
  value?: number | null;
}

export interface FormSetCausation {
  card_id: string;
  ceiling_hash: string;
  ceiling_revision: number;
  run_id: string;
}

export interface FormSetPatientDto {
  birthday?: string | null;
  cpf?: string | null;
  cpf_of_the_person_responsible?: string | null;
  email?: string | null;
  gender?: "M" | "F" | null;
  name: string;
  name_of_person_responsible?: string | null;
  phone?: string | null;
}

export interface FormSetPatientRef {
  $ref: "e1.result.id";
}

export interface FormSetSubmitRequest {
  causation: FormSetCausation;
  elements: { e1: FormSetPatientDto; e2: FormSetAppointmentDto; };
  request_key: string;
}

export interface FormSetAppointmentReceipt {
  capability: "confirm_appointment";
  effect_id: string;
  follow_ups: Array<FormSetFollowUp>;
  hitl_item_id: string;
  key: "e2";
  policy_decision_id: string;
  result_ref: FormSetSchedulingResultRef;
  state: "applied";
}

export type FormSetElementReceipt = FormSetAppointmentReceipt | FormSetPatientReceipt;

export interface FormSetFollowUp {
  kind: "patient_message";
  reason: "not_in_scope";
  state: "not_sent";
}

export interface FormSetPatientReceipt {
  capability: "confirm_patient";
  effect_id: string;
  follow_ups: Array<FormSetFollowUp>;
  hitl_item_id: string;
  key: "e1";
  policy_decision_id: string;
  result_ref: FormSetPatientResultRef;
  state: "applied";
}

export interface FormSetPatientResultRef {
  id: string;
  type: "patient";
}

export interface FormSetSchedulingResultRef {
  id: string;
  type: "scheduling";
}

export interface FormSetReceipt {
  ceiling_revision: number;
  committed_at: string;
  elements: Array<FormSetElementReceipt>;
  follow_ups: Array<FormSetFollowUp>;
  replayed: boolean;
  set_effect_id: string;
  shape: "patient_then_appointment";
  state: "applied";
}

export interface FormSetElementError {
  admissible: boolean;
  fields?: Record<string, Array<string>>;
  reason?: "permission" | "policy_level" | "not_admitted";
}

export interface FormSetElementRefused {
  admissible: false;
  fields?: Record<string, Array<string>>;
  reason: "permission" | "policy_level" | "not_admitted";
}

export interface FormSetElements {
  e1: FormSetElementError;
  e2: FormSetElementError;
}

export interface FormSetErrorDetails {
  elements?: FormSetElements | FormSetNoElements;
  fields?: Record<string, Array<string>>;
}

export interface FormSetForbiddenDetails {
  elements: FormSetForbiddenElements;
}

export interface FormSetForbiddenE1 {
  e1: FormSetElementRefused;
  e2: FormSetElementError;
}

export interface FormSetForbiddenE2 {
  e1: FormSetElementError;
  e2: FormSetElementRefused;
}

export type FormSetForbiddenElements = FormSetForbiddenE1 | FormSetForbiddenE2;

export type FormSetNoElements = Record<string, never>;

export interface FormSetErrorBase {
  message: string;
  retry_possible: boolean;
  status: "error";
  user_message: string;
}

export type FormSetError =
  | (FormSetErrorBase & { details?: FormSetErrorDetails; error_type: "tool_validation_error"; reason_code: "copilot_effect_invalid"; })
  | (FormSetErrorBase & { details?: FormSetErrorDetails; error_type: "effect_domain_conflict"; reason_code: "effect_domain_conflict"; })
  | (FormSetErrorBase & { details: FormSetForbiddenDetails; error_type: "effect_forbidden"; reason_code: "effect_forbidden"; })
  | (FormSetErrorBase & { details?: FormSetErrorDetails; error_type: "effect_identity_conflict"; reason_code: "effect_identity_conflict"; })
  | (FormSetErrorBase & { details?: FormSetErrorDetails; error_type: "set_shape_stale"; reason_code: "set_shape_stale"; })
  | (FormSetErrorBase & { details?: FormSetErrorDetails; error_type: "deployment_unavailable"; reason_code: "deployment_unavailable"; })
  | (FormSetErrorBase & { details?: FormSetErrorDetails; error_type: "set_receipt_not_found"; reason_code: "set_receipt_not_found"; });

export const FORM_SET_SHAPES = {
  "patient_then_appointment": {
    "elements": {
      "e1": "confirm_patient",
      "e2": "confirm_appointment"
    },
    "max_elements": 2,
    "refs": {
      "e2.patientsId": "e1.result.id"
    }
  }
} as const;

export const FORM_SET_FIELD_MAP = {
  "actions": {
    "confirm_appointment": {
      "comments": null,
      "date": "date",
      "employeesId": "professional",
      "hour": "time",
      "patientsId": "patient_id",
      "proceduresId": "procedure",
      "return": null,
      "value": "value"
    },
    "confirm_patient": {
      "birthday": "birthday",
      "cpf": "cpf",
      "cpf_of_the_person_responsible": "responsible_cpf",
      "email": "email",
      "gender": "gender",
      "name": "name",
      "name_of_person_responsible": "responsible_name",
      "phone": "phone"
    }
  },
  "results": {
    "confirm_appointment": "scheduling_id",
    "confirm_patient": "patient_id"
  }
} as const;

// --- Media limits - copilot/media/v1 -------------------------------------------

export interface MediaLimits {
  max_attachments: number;
  max_file_bytes: number;
  max_turn_bytes: number;
  pdf_max_pages: number;
}

export const MEDIA_LIMITS = {
  "max_attachments": 5,
  "max_file_bytes": 10485760,
  "max_turn_bytes": 20971520,
  "pdf_max_pages": 3
} as const;

// --- Agent run states - copilot/agent-run-states.json --------------------------

export const AGENT_RUN_STATES = [
  "cancelled",
  "done",
  "failed",
  "leased",
  "queued",
  "retry_wait",
  "running",
  "superseded",
  "waiting_approval",
] as const;

export type AgentRunState = (typeof AGENT_RUN_STATES)[number];

export type AgentRunEvent =
  | "approval_expired"
  | "approval_required"
  | "approved"
  | "backoff_elapsed"
  | "budget_or_cost_cap_exhausted"
  | "cancel"
  | "deadline_passed"
  | "heartbeat"
  | "lease_expired"
  | "non_retryable_failure"
  | "not_before_unreached"
  | "rejected"
  | "retryable_failure"
  | "run_starts"
  | "superseded_by_newer"
  | "task_created"
  | "work_completes"
  | "worker_claims";

export type AgentRunTerminalReason =
  | "approval_expired"
  | "approval_rejected"
  | "deadline_exceeded"
  | "lease_lost"
  | "task_cancelled"
  | "task_superseded";

export const AGENT_RUN_TRANSITIONS = [
  {
    creates_attempt: true,
    event: "worker_claims",
    from: "queued",
    note: "one atomic step: the agent_runs row is created (attempt incremented) and its lease taken in the same transaction",
    to: "leased",
  },
  {
    event: "not_before_unreached",
    from: "queued",
    no_op: true,
    note: "the task is simply not claimable yet",
    to: "queued",
  },
  {
    event: "cancel",
    from: "queued",
    terminal_reason: "task_cancelled",
    to: "cancelled",
  },
  {
    event: "superseded_by_newer",
    from: "queued",
    note: "matched on supersession_key; the two tasks keep distinct effect_ids",
    terminal_reason: "task_superseded",
    to: "superseded",
  },
  {
    event: "deadline_passed",
    from: "queued",
    terminal_reason: "deadline_exceeded",
    to: "failed",
  },
  {
    creates_attempt: false,
    event: "run_starts",
    from: "leased",
    note: "the existing run begins executing; no row is created here",
    to: "running",
  },
  {
    closes_run: "failed",
    closes_run_reason: "lease_lost",
    event: "lease_expired",
    from: "leased",
    to: "queued",
  },
  {
    event: "cancel",
    from: "leased",
    terminal_reason: "task_cancelled",
    to: "cancelled",
  },
  {
    event: "heartbeat",
    from: "running",
    no_op: true,
    note: "heartbeat_at refreshed",
    to: "running",
  },
  {
    closes_run: "failed",
    closes_run_reason: "lease_lost",
    event: "lease_expired",
    from: "running",
    to: "queued",
  },
  {
    event: "approval_required",
    from: "running",
    note: "HITL item created, carrying effect_id",
    to: "waiting_approval",
  },
  {
    event: "retryable_failure",
    from: "running",
    note: "only for an effect with an honoured effect_id (section 6.2)",
    to: "retry_wait",
  },
  {
    event: "non_retryable_failure",
    from: "running",
    terminal_reason_source: "adr_0006",
    to: "failed",
  },
  {
    event: "work_completes",
    from: "running",
    note: "the idempotent result callback has landed; a success carries no terminal reason",
    to: "done",
  },
  {
    event: "cancel",
    from: "running",
    terminal_reason: "task_cancelled",
    to: "cancelled",
  },
  {
    event: "budget_or_cost_cap_exhausted",
    from: "running",
    terminal_reason_source: "budget",
    to: "failed",
  },
  {
    creates_attempt: false,
    event: "approved",
    from: "waiting_approval",
    note: "the SAME agent_run is re-leased - new lease_owner and lease_expires_at, attempt unchanged",
    resume: true,
    to: "leased",
  },
  {
    event: "rejected",
    from: "waiting_approval",
    terminal_reason: "approval_rejected",
    to: "failed",
  },
  {
    event: "approval_expired",
    from: "waiting_approval",
    terminal_reason: "approval_expired",
    to: "failed",
  },
  {
    event: "cancel",
    from: "waiting_approval",
    note: "a later approval for this task is refused with task_cancelled and the HITL item closes cancelled",
    terminal_reason: "task_cancelled",
    to: "cancelled",
  },
  {
    event: "superseded_by_newer",
    from: "waiting_approval",
    note: "the pending HITL item closes cancelled",
    terminal_reason: "task_superseded",
    to: "superseded",
  },
  {
    event: "backoff_elapsed",
    from: "retry_wait",
    to: "queued",
  },
  {
    event: "cancel",
    from: "retry_wait",
    terminal_reason: "task_cancelled",
    to: "cancelled",
  },
  {
    event: "deadline_passed",
    from: "retry_wait",
    terminal_reason: "deadline_exceeded",
    to: "failed",
  },
] as const;
